/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IndustriesResponse } from '../../models/industries-response';

export interface DataAnalyticsIndustries$Params {
  count: number;
  days: number;
}

export function dataAnalyticsIndustries(http: HttpClient, rootUrl: string, params: DataAnalyticsIndustries$Params, context?: HttpContext): Observable<StrictHttpResponse<IndustriesResponse>> {
  const rb = new RequestBuilder(rootUrl, dataAnalyticsIndustries.PATH, 'get');
  if (params) {
    rb.path('count', params.count, {});
    rb.path('days', params.days, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IndustriesResponse>;
    })
  );
}

dataAnalyticsIndustries.PATH = '/rest/data-analytics/industries/{count}/{days}';
